/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceSimpleTypeEnum,
    LearningCompetenceSimpleTypeEnumFromJSON,
    LearningCompetenceSimpleTypeEnumFromJSONTyped,
    LearningCompetenceSimpleTypeEnumToJSON,
} from './LearningCompetenceSimpleTypeEnum';

/**
 * 
 * @export
 * @interface LearningCompetencesQueryParams
 */
export interface LearningCompetencesQueryParams {
    /**
     * 
     * @type {number}
     * @memberof LearningCompetencesQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof LearningCompetencesQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetencesQueryParams
     */
    name?: string | null;
    /**
     * 
     * @type {LearningCompetenceSimpleTypeEnum}
     * @memberof LearningCompetencesQueryParams
     */
    type?: LearningCompetenceSimpleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetencesQueryParams
     */
    programId?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetencesQueryParams
     */
    studyPlanId?: string;
}

export function LearningCompetencesQueryParamsFromJSON(json: any): LearningCompetencesQueryParams {
    return LearningCompetencesQueryParamsFromJSONTyped(json, false);
}

export function LearningCompetencesQueryParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningCompetencesQueryParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceSimpleTypeEnumFromJSON(json['type']),
        'programId': !exists(json, 'programId') ? undefined : json['programId'],
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
    };
}

export function LearningCompetencesQueryParamsToJSON(value?: LearningCompetencesQueryParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'name': value.name,
        'type': LearningCompetenceSimpleTypeEnumToJSON(value.type),
        'programId': value.programId,
        'studyPlanId': value.studyPlanId,
    };
}

